export default {
  title: 'Comparte este contenido',
  doneModal: '¡Gracias!'
}

export const en = {
  title: 'Share this content',
  doneModal: 'Thank you!'
}

export const ca = {
  title: 'Comparteix el contingut',
  doneModal: 'Gràcies!'
}
